<template>
  <div ref="current_container" class="container-fluid overflow-auto page-container-h">
    <bread-crumb ref="bread_crumb" :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <b-tabs
      ref="tabs"
      v-model="search.type"
      pills
      class="mb-4"
      @input="getReportAllBill()"
    >
      <b-tab
        v-for="(item, index) in options.type"
        :key="index"
        :title="item.label"
      />
    </b-tabs>

    <tables-page
      :tableData="data.table_data"
      :tableFields="data.table_fields"
      :pageData="data.page"
      v-on:result="getReportAllBill"
    >
      <template #cell(a)="row">
        <template v-if="!row.item.divider">
          <span
            class="link"
            v-if="row.item.type === 'count_unpay'"
            @click="openbillModal(row.item.a)"
          >
            {{ Thousands(row.item.a.value) }}
          </span>

          <span v-else>{{ Thousands(row.item.a.value) }}</span>
        </template>
      </template>

      <template #cell(b)="row">
        <template v-if="!row.item.divider">
          <span
            class="link"
            v-if="row.item.type === 'count_unpay'"
            @click="openbillModal(row.item.b)"
          >
          {{ Thousands(row.item.b.value) }}
          </span>

          <span v-else>{{ Thousands(row.item.b.value) }}</span>
        </template>
      </template>

      <template #cell(total)="row">
        <template v-if="!row.item.divider">
          {{ Thousands(row.item.total) }}
        </template>
      </template>
    </tables-page>

    <!-- 帳單 modal -->
    <bill-data-report-bill-modal
      v-model="status.billModal"
      :data="data.temp_table_data" />
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import reportApi from "@/models/API/reportApi";
import TablesPage from "@/components/layouts/TablesPage";
import billDataReportBillModal from"./components/modal/billDataReportBillModal";
import { Thousands } from "@/models/HELPERS/common.js";

export default {
  name: 'billDataReport',
  components: {
    BreadCrumb,
    TablesPage,
    billDataReportBillModal
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '報表', url: '', isActive: true },
          { name: '帳單相關數據', url: '', isActive: false }
        ]
      },
      options: {
        type: [
          { value: 0, label: '全部', key: '' },
          { value: 1, label: '月費', key: 'M' },
          { value: 2, label: '平台年費', key: 'Y' },
          { value: 3, label: '手續費', key: 'F' },
          { value: 4, label: '回饋金', key: 'S' },
          { value: 5, label: '墊繳手續費', key: 'B' }
        ],
      },
      status: {
        billModal: false
      },
      search: {
        type: 0,
      },
      data: {
        table_fields: [
          {
            key: "group",
            label: "組別",
          },
          {
            key: "a",
            label: "A：永保",
          },
          {
            key: "b",
            label: "B：長安",
          },
          {
            key: "total",
            label: "合計",
          }
        ],
        table_data: [],
        statistics_table_data: [],
        bill_table_data: [],
        page: {},
        temp_table_data: {},
      }
    }
  },
  computed: {

  },
  mounted() {
    this.reportApi = new reportApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.data.page = Object.assign({}, this.reportApi.page);
      this.getReportAllMember();
    },
    Thousands,
    // 取得契約各組相關數據總表
    getReportAllMember() {
      this.reportApi.getReportAllMember((response) => {
        const res = response.data;
        const data = res.data[0];

        this.data.statistics_table_data = [
          {
            group: '正常組數',
            a: {
              plan: 'a',
              value: data.member_A_status_0
            },
            b: {
              plan: 'b',
              value: data.member_B_status_0
            },
            total: data.member_A_status_0 + data.member_B_status_0
          },
          {
            group: '身故組數',
            a: {
              plan: 'a',
              value: data.member_A_status_1
            },
            b: {
              plan: 'b',
              value: data.member_B_status_1
            },
            total: data.member_A_status_1 + data.member_B_status_1
          },
          {
            group: '停效組數',
            a: {
              plan: 'a',
              value: data.member_A_status_2
            },
            b: {
              plan: 'b',
              value: data.member_B_status_2
            },
            total: data.member_A_status_2 + data.member_B_status_2
          },
          {
            group: '除會組數',
            a: {
              plan: 'a',
              value: data.member_A_status_3
            },
            b: {
              plan: 'b',
              value: data.member_B_status_3
            },
            total: data.member_A_status_3 + data.member_B_status_3
          },
          {
            group: '墊繳組數',
            a: {
              plan: 'a',
              value: data.member_A_status_4
            },
            b: {
              plan: 'b',
              value: data.member_B_status_4
            },
            total: data.member_A_status_4 + data.member_B_status_4,
            status: 4
          },
          {
            group: '總組數',
            a: {
              plan: 'a',
              value: data.member_A_total
            },
            b: {
              plan: 'b',
              value: data.member_B_total
            },
            total: data.member_A_total + data.member_B_total
          }
        ];

        this.getReportAllBill();
      })
    },
    // 取得帳單相關數據總表
    getReportAllBill(pageIndex = null) {
      const type = this.options.type.find(item => item.value === this.search.type).key;
      const params = {
        'type': type,
        'PageSize': this.data.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.data.page.pageIndex,
      };

      this.reportApi.getReportAllBill((response) => {
        const res = response.data;

        this.data.page.totalCount = res.total; // 總筆數
        this.data.bill_table_data = [];

        res.data.forEach(item => {
          const pay_a = Math.floor(item.sum_A_pay / (item.sum_A_pay + item.sum_A_unpay) * 100);
          const pay_b = Math.floor(item.sum_B_pay / (item.sum_B_pay + item.sum_B_unpay) * 100);
          const pay_a_b = Math.floor((item.sum_A_pay + item.sum_B_pay) / ((item.sum_A_pay + item.sum_B_pay) + (item.sum_A_unpay + item.sum_B_unpay)) * 100);

          const bill_type = this.options.type.find(item => item.value === this.search.type).key;

          this.data.bill_table_data.push(
            {
              divider: true,
              body_tr_bg: 'bg-green'
            },
            {
              divider: false,
              group: `${item.period}已繳筆數`,
              a: {
                plan: 'a',
                bill_type: bill_type,
                value: item.count_A_pay,
                period: item.period
              },
              b: {
                plan: 'b',
                bill_type: bill_type,
                value: item.count_B_pay,
                period: item.period
              },
              total: item.count_A_pay + item.count_B_pay,
              type: 'count_pay'
            },
            {
              divider: false,
              group: `${item.period}已繳金額`,
              a: {
                plan: 'a',
                bill_type: bill_type,
                value: item.sum_A_pay,
                period: item.period
              },
              b: {
                plan: 'b',
                bill_type: bill_type,
                value: item.sum_B_pay,
                period: item.period
              },
              total: item.sum_A_pay + item.sum_B_pay,
              type: 'sum_pay'
            },
            {
              divider: false,
              group: `${item.period}已繳金額%`,
              a: {
                plan: 'a',
                bill_type: bill_type,
                value: `${pay_a}%`,
                period: item.period
              },
              b: {
                plan: 'b',
                bill_type: bill_type,
                value: `${pay_b}%`,
                period: item.period
              },
              total: `${pay_a_b}%`,
              type: 'sum_pay_percentage'
            },
            {
              divider: false,
              group: `${item.period}未繳筆數`,
              a: {
                plan: 'a',
                bill_type: bill_type,
                value: item.count_A_unpay,
                period: item.period
              },
              b: {
                plan: 'b',
                bill_type: bill_type,
                value: item.count_B_unpay,
                period: item.period
              },
              total: item.count_A_unpay + item.count_B_unpay,
              type: 'count_unpay'
            },
            {
              divider: false,
              group: `${item.period}未繳金額`,
              a: {
                plan: 'a',
                bill_type: bill_type,
                value: item.sum_A_unpay,
                period: item.period
              },
              b: {
                plan: 'b',
                bill_type: bill_type,
                value: item.sum_B_unpay,
                period: item.period
              },
              total: item.sum_A_unpay + item.sum_B_unpay,
              type: 'sum_unpay'
            },
            {
              divider: false,
              group: `${item.period}未繳金額%`,
              a: {
                plan: 'a',
                bill_type: bill_type,
                value: `${100 - pay_a}%`,
                period: item.period
              },
              b: {
                plan: 'b',
                bill_type: bill_type,
                value: `${100 - pay_b}%`,
                period: item.period
              },
              total: `${100 - pay_a_b}%`,
              type: 'sum_unpay_percentage'
            },
            {
              divider: false,
              group: `${item.period}金額合計`,
              a: {
                plan: 'a',
                bill_type: bill_type,
                value: item.sum_A,
                period: item.period
              },
              b: {
                plan: 'b',
                bill_type: bill_type,
                value: item.sum_B,
                period: item.period
              },
              total: item.sum_A + item.sum_B,
              type: 'sum'
            },
          )

          this.data.table_data = [...this.data.statistics_table_data, ...this.data.bill_table_data];
        });
      }, params)
    },
    // 開啟帳單 modal
    openbillModal(item) {
      this.status.billModal = true;
      this.data.temp_table_data = Object.assign({}, item);
    }
  }
}
</script>

<style lang="scss" scoped>
.table-page {
  /deep/ table {
    thead {
      tr {
        th {
          &.statistics-thead-title {
            background: #28a745;
            color: #FFF;
            font-size: 18px;
          }
          &.contract-thead-title {
            background: #007bff;
            color: #FFF;
            font-size: 18px;
          }
        }
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/billDataReport.vue